// Pure helpers for the Audit page's improvement panel (QualityLoopPanel.jsx,
// phase 4, docs/quality-improvement.md). No React, so node --test covers them.

export const WHY_LABEL = {
  intent_overridden: 'Intent was overridden',
  order_not_found: 'Order not found',
  no_flow: 'No flow for this turn',
  no_flow_row: 'Flow has no catalog row',
  step_not_proposed: 'Person ran a step the AI did not propose',
  draft_changed: 'Person changed the reply',
  step_skipped: 'A proposed step was not run',
  needs_human_review: 'Held for a person by a rule',
  flow_not_automated: 'Flow not set to Automate',
  manual_close: 'Closed by hand, no AI turn',
  other: 'Other',
}

export const TAG_LABEL = { ai: 'AI', data: 'Data', process: 'Process', unclassified: 'Unclassified' }

export const OUTCOME_LABEL = { better: 'Better', worse: 'Worse', tie: 'Tie', unknown: 'Unknown' }

export function pct(v) {
  return v == null ? '—' : `${Math.round(v * 100)}%`
}

export function codeLabel(code) {
  return String(code ?? '').replaceAll('_', ' ')
}

// The form's fields -> the POST /fixes body, or { error } with a sentence.
// A candidate fix is data: one stage, a prompt addition or replacement, and
// optionally a model from the server's allowlist.
// window: the gaps view's { from, to } when the gap was picked there, so
// the replay samples the same contacts.
export function fixRequest({ gapKey, window = null, title, stage, mode, text, model }, { models = [] } = {}) {
  if (!gapKey) return { error: 'Pick a gap or a failure group first.' }
  const t = String(title ?? '').trim()
  if (!t) return { error: 'Give the fix a short name.' }
  if (t.length > 120) return { error: 'Keep the name under 120 characters.' }
  if (stage !== 'draft' && stage !== 'classify') return { error: 'Pick the stage the fix changes.' }
  const body = String(text ?? '').trim()
  const s = {}
  if (body) s[mode === 'replace' ? 'systemReplace' : 'systemAppend'] = body
  if (model) {
    if (!models.includes(model)) return { error: 'That model is not on the allowlist.' }
    s.model = model
  }
  if (!Object.keys(s).length) return { error: 'Add a prompt change or pick a model.' }
  return { body: { gapKey, title: t, overlay: { [stage]: s }, ...(window?.from && window?.to ? { window: { from: window.from, to: window.to } } : {}) } }
}

// A sentence for an error from the quality routes.
export function qualityErrorMessage(err) {
  const code = err?.body?.error
  if (err?.status === 404 && code === 'quality_loop_off') return 'The improvement views are not enabled (QUALITY_LOOP_VIEW_ENABLED).'
  if (err?.status === 404 && code === 'replay_off') return 'Replays are not enabled (QUALITY_REPLAY_ENABLED).'
  if (code === 'run_in_progress') return 'A replay is already running. One runs at a time.'
  if (code === 'model_not_allowed') return 'That model is not on the allowlist.'
  if (code === 'model_not_priced') return 'That model has no price in AI_MODEL_PRICES, so its cost is unknown. A replay refuses it.'
  if (code === 'overlay_text_not_certified') return 'The prompt text could not be checked for personal data (the Language pass did not certify it), so it was not saved. Try again later.'
  if (code === 'no_daily_limit') return 'No daily replay spend cap is set (QUALITY_REPLAY_DAILY_LIMIT_USD), so replays cannot start.'
  if (code === 'daily_limit_reached') return 'Today\'s replay spend cap is reached. Replays start again tomorrow (UTC).'
  if (code) return `Refused: ${codeLabel(code)}.`
  return 'The server could not be reached.'
}

// "better 3, worse 1, tie 2, unknown 0 (of 6 graded)".
export function tallyLine(t) {
  if (!t) return 'Not replayed yet.'
  const graded = (t.better ?? 0) + (t.worse ?? 0) + (t.tie ?? 0) + (t.unknown ?? 0)
  if (!graded) return 'Nothing graded yet.'
  return `better ${t.better ?? 0}, worse ${t.worse ?? 0}, tie ${t.tie ?? 0}, unknown ${t.unknown ?? 0} (of ${graded} graded)`
}
